/**
 * Translation service for auto-translating text to Arabic
 * Uses free MyMemory Translation API (no API key required)
 */

/**
 * Translate text from English to Arabic using MyMemory API
 * @param {string} text - Text to translate
 * @returns {Promise<string>} - Translated text in Arabic
 */
export const translateToArabic = async (text) => {
  try {
    if (!text || !text.trim()) {
      return '';
    }

    // Use MyMemory Translation API (free, no API key needed)
    const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|ar`;
    
    const response = await fetch(url);
    const data = await response.json();
    
    if (data.responseStatus === 200 && data.responseData) {
      return data.responseData.translatedText;
    }
    
    return '';
  } catch (error) {
    console.error('Translation error:', error);
    // Return empty string on error, don't block the user
    return '';
  }
};

/**
 * Debounce function to limit API calls
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in milliseconds
 * @returns {Function} - Debounced function
 */
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

